import { saveAs } from "file-saver"
import React, { useState, useRef, useEffect } from "react"
import { Alert } from "react-bootstrap"
import { ClipLoader } from "react-spinners"
import { GenDocFileDownload } from "../../../api/AuthService"
import { GENDOCFILE_DOWNLOAD } from "../../../constant/Constants"
import CustomLink from "./CustomLink"

const GenDocsFilesDownload = (props) => {
   let requestFrom =props.requestFrom || ""
   const [changeOccure, setChangeOccure] = useState(false)
   const [partName] = useState(props.partName)

   useEffect(() => {
      if (changeOccure) {
         const delay = setTimeout(() => {
            props.handleDiffCategory(props.name)
         }, 1000) // Add a 1-second delay

         // Cleanup the timeout to avoid memory leaks
         return () => clearTimeout(delay)
      }
   }, [changeOccure, props.name, props.handleDiffCategory])

   const headerContent = props.headerContent
   var numRows = 0

   var prevNumRows = 0

   const [data, setData] = useState()
   const [previousData, setPreviousData] = useState()

   useEffect(() => {
      if (props.data) {
         setData(props.data.sort())
      }
      if (props.previousData) {
         setPreviousData(props.previousData.sort())
      }
   }, [props.data, props.previousData])

   const [loading, setLoading] = useState(false)
   const [show, setShow] = useState(false)
   const [errorMeg, setErrorMsg] = useState(false)

   if (data != null && data.length > 0) {
      numRows = data.length
   }

   if (previousData != null && previousData.length > 0) {
      prevNumRows = previousData.length
   }

   const containerRef = useRef(null)
   const table1Ref = useRef(null)
   const table2Ref = useRef(null)

   useEffect(() => {
      const synchronizeRowHeights = () => {
         const table1Rows = table1Ref.current?.querySelectorAll("tr") || []
         const table2Rows = table2Ref.current?.querySelectorAll("tr") || []

         // Ensure both tables have the same number of rows
         const rowCount = Math.min(table1Rows.length, table2Rows.length)

         for (let i = 0; i < rowCount; i++) {
            const table1Row = table1Rows[i]
            const table2Row = table2Rows[i]

            // Get the maximum height of the two rows
            const maxHeight = Math.max(table1Row.offsetHeight, table2Row.offsetHeight)

            // Apply the maximum height to both rows
            table1Row.style.height = `${maxHeight}px`
            table2Row.style.height = `${maxHeight}px`
         }
      }

      // Synchronize row heights initially
      synchronizeRowHeights()

      // Synchronize row heights on window resize
      window.addEventListener("resize", synchronizeRowHeights)

      return () => {
         window.removeEventListener("resize", synchronizeRowHeights)
      }
   }, [data, previousData])

   useEffect(() => {
      const handleScroll = () => {
         if (table1Ref.current && table2Ref.current) {
            table2Ref.current.scrollTop = table1Ref.current.scrollTop
            table2Ref.current.scrollLeft = table1Ref.current.scrollLeft
         }
      }

      const table1 = table1Ref.current
      if (table1) {
         table1.addEventListener("scroll", handleScroll)
      }

      return () => {
         if (table1) {
            table1.removeEventListener("scroll", handleScroll)
         }
      }
   }, [data, previousData])

   const compareObjects = (current, previous, parentKey = "") => {
      let differences = {}

      if (
         typeof current === "object" &&
         current !== null &&
         typeof previous === "object" &&
         previous !== null
      ) {
         // If both are objects, compare their keys recursively
         const keys = new Set([...Object.keys(current), ...Object.keys(previous)])
         keys.forEach((key) => {
            // Skip comparing the 'filepath' key
            if (key.toLowerCase() === "filepath" || key.toLowerCase() === "action") {
               return
            }
            const newKey = parentKey ? `${parentKey}.${key}` : key // Flatten the key
            Object.assign(
               differences,
               compareObjects(current[key], previous[key], newKey)
            )
         })
      } else {
         // For primitive values, compare directly
         const flattenedKey = parentKey
         differences[flattenedKey] = current === previous ? "same" : "different"
      }

      return differences
   }

   const differencesInEachRow = (index) => {
      let differencesInRow = {}
      // Ensure both rows exist
      if (data[index] && previousData[index]) {
         // Check if the current row is empty
         const isCurrRowEmpty = Object.values(data[index]).every((value) => {
            if (typeof value === "object" && value !== null) {
               // Check if sub-object is empty
               return Object.values(value).every((subValue) => !subValue)
            }
            return !value // Check if the value itself is empty
         })

         // Check if the previous row is empty
         const isPrevRowEmpty = Object.values(previousData[index]).every((value) => {
            if (typeof value === "object" && value !== null) {
               // Check if sub-object is empty
               return Object.values(value).every((subValue) => !subValue)
            }
            return !value // Check if the value itself is empty
         })

         // Perform comparison only if both rows are not empty
         if (!isCurrRowEmpty && !isPrevRowEmpty) {
            differencesInRow = compareObjects(data[index], previousData[index])
         }
      }

      return differencesInRow
   }

   const getHeader = (headerData = []) => {
      var keys = getKeys(headerData)

      return keys.map((key, index) => {
         if (
            key.toLowerCase() === "id" ||
            key.toLowerCase() === "link" ||
            key.toLowerCase() === "filepath" ||
            key.toLowerCase() === "gendoc" ||
            key.toLowerCase() === "file name"
         ) {
            return null
         }
         if (key.toLowerCase() === "zcsurl") {
            return <th key={key}></th>
         }
         if (key.toLowerCase() === "action") {
            return <th key={key}></th>
         }
         return (
            <th key={key}>
               <span>{key}</span>
            </th>
         )
      })
   }

   const getKeys = (keysInformation = []) => {
      return Object.keys(keysInformation)
   }
   const getColumnKeys = (columKeyInfo) => {
      return Object.keys(columKeyInfo)
   }

   const RenderColumn = (props) => {
      return props.keys.map((key, index) => {
         if (props.data[key] !== "" && props.data[key] != null)
            return (
               <div key={index}>
                  <span className={props.isbold ? "bomFontClass" : ""}>{key}:</span>{" "}
                  <span>{props.data[key]}</span>
               </div>
            )
         else return null
      })
   }

   const getRowsData = (tableData) => {
      var items = tableData
      var keys = getKeys(tableData[0])
      let backgroundColor = ""
      return items.map((row, index) => {
         // Check if the row or its sub-objects are empty
         const isRowEmpty =
            !row ||
            Object.values(row).every((value) => {
               if (typeof value === "object" && value !== null) {
                  // Check if sub-object is empty
                  return Object.values(value).every((subValue) => !subValue)
               }
               return !value // Check if the value itself is empty
            })

         if (isRowEmpty) {
            // Render an empty row
            if (changeOccure == false) {
               setChangeOccure(true)
               props.handleDiffCategory(props.name)
            }
            return (
               <tr key={index}>
                  <td colSpan={keys.length} style={{ backgroundColor: "#ffcccc" }}></td>
               </tr>
            )
         }
         let differencesInRow = differencesInEachRow(index)

         if (Object.values(differencesInRow).includes("different")) {
            if (changeOccure == false) {
               setChangeOccure(true)
               props.handleDiffCategory(props.name)
            }
            backgroundColor = "#ffcccc"
         } else {
            backgroundColor = "white"
         }
         return (
            <tr key={index} style={{ backgroundColor: backgroundColor }}>
               <RenderRow
                  key={index}
                  data={row}
                  keys={keys}
                  differencesInRow={differencesInRow}
               />
            </tr>
         )
      })
   }

   const RenderRow = (props) => {
      return props.keys.map((key, index) => {
         if (props.data[key] != null && typeof props.data[key] === "object") {
            var colKeys = getColumnKeys(props.data[key])
            return (
               <td key={index}>
                  <RenderColumn data={props.data[key]} isbold={true} keys={colKeys} />
               </td>
            )
         } else if (
            key.toLowerCase() === "name" &&
            props.data["id"] &&
            props.data["id"].toLowerCase().trim() !== "no access"
         ) {
            var name = props.data[key]
            return (
               <td style={{ minWidth: "9rem" }} key={index}>
                  {props.data["link"] && props.data["link"] !== "" && props.data["id"] ? (
                     <CustomLink
                        id={props.data["id"]}
                        link={props.data["link"]}
                        name={name}
                     />
                  ) : (
                     <span>{name}</span>
                  )}
               </td>
            )
         }
         if (key.toLowerCase() === "action") {
            let fileName = props.data["File Name"]
               ? props.data["File Name"]
               : props.data["Name"]

            return (
               <td key={index}>
                  {props.data[key] && fileName && props.data["filepath"] ? (
                     ""
                  ) : (
                     ""
                  )}
               </td>
            )
         } else if (
            key.toLowerCase() === "id" ||
            key.toLowerCase() === "link" ||
            key.toLowerCase() === "filepath" ||
            key.toLowerCase() === "gendoc" ||
            key.toLowerCase() === "file name"
         ) {
            return null
         } else {
            if (props.differencesInRow[`${key}`] === "different") {
               return (
                  <td key={index} style={{ color: "red", fontWeight: "bold" }}>
                     {props.data[key]}
                  </td>
               )
            }

            return <td key={index}>{props.data[key]}</td>
         }
      })
   }

   const downloadGenDocFiles = (fileName, filePath, filetype) => {
      setLoading(true)

      let specialRegex = /[`!@#$%^&*()+={};':"\\|<>?~]/
      headerContent &&
         Object.entries(headerContent).forEach(
            ([key, val]) =>
               val &&
               typeof val !== "object" &&
               specialRegex.test(val) &&
               delete headerContent[key]
         )
      GenDocFileDownload(
         `${GENDOCFILE_DOWNLOAD}`,
         btoa(unescape(encodeURIComponent(fileName))),
         btoa(filePath),
         filetype,
         {},
         headerContent,
         "",
         "",
         requestFrom
      )
         .then((response) => {
            const fileContents = new Blob([response.data])
            saveAs(fileContents, fileName)
            setLoading(false)
         })
         .catch((error) => {
            if (error.response && error.response.status === 404) {
               setShow(true)
               setErrorMsg(`"${fileName} is not available to download."`)
            } else if (error.response && error.response.status === 403) {
               setShow(true)
               setErrorMsg("There is a file download error -  please contact Support.")
            } else if (error.response && error.response.status === 422) {
               setShow(true)
               setErrorMsg(
                  "You have exceeded the limit for the day and access to any additional Part/Specification is blocked! Please contact Support."
               )
            } else {
               setShow(true)
               setErrorMsg("Oops, something went wrong. Please contact Support.")
               console.log("FCS Error Response:-", error)
            }
            setLoading(false)
         })
   }

   if (show) {
      return (
         <Alert
            style={{ textAlign: "center", marginLeft: "8rem", marginRight: "8rem" }}
            variant="info"
            onClose={() => setShow(false)}
            dismissible
         >
            <p>{errorMeg}</p>
         </Alert>
      )
   }

   return (
      <div className="tableFixHead">
         <div ref={containerRef} style={{ display: "flex" }}>
            <div
               ref={table1Ref}
               style={{ width: "50%", overflow: "auto", maxHeight: "60vh", position: "relative" }}
            >
               {props.revision && props.revision !== "" && (
                  <div
                     style={{
                        position: "sticky",
                        top: "0",
                        backgroundColor: "#EEEEEE",
                        textAlign: "center",
                        fontWeight: "bold",
                     }}
                  >
                     {partName} {props.revision["releaseRevision"]}
                  </div>
               )}
               {numRows > 0 && (
                  <div style={{ position: 'relative' }}>
                     {loading && (
                        <div style={{
                           position: 'absolute',
                           top: 0,
                           left: 0,
                           right: 0,
                           bottom: 0,
                           display: 'flex',
                           flexDirection: 'column',
                           alignItems: 'center',
                           justifyContent: 'center',
                           backgroundColor: 'rgba(255, 255, 255, 0.8)',
                           zIndex: 1000
                        }}>
                           <ClipLoader color="#0173d4" loading={loading} size={50} />
                           <p style={{ marginTop: '10px', color: '#0173d4', fontWeight: 'bold' }}>Downloading.......</p>
                        </div>
                     )}
                     <table className="tableBorder">
                        <thead
                           style={{
                              visibility:
                                 props.isHeader !== "false" ? "visible" : "collapse",
                           }}
                        >
                           <tr style={{backgroundColor:"#eee"}}>{getHeader(data[0])}</tr>
                        </thead>
                        <tbody>{getRowsData(data)}</tbody>
                     </table>
                  </div>
               )}
            </div>

            <div
               ref={table2Ref}
               style={{ width: "50%", overflow: "auto", maxHeight: "60vh", position: "relative" }}
            >
               {props.revision && props.revision !== "" && (
                  <div
                     style={{
                        position: "sticky",
                        top: "0",
                        backgroundColor: "#EEEEEE",
                        textAlign: "center",
                        fontWeight: "bold",
                     }}
                  >
                     {partName} {props.revision["obsoleteRevision"]}
                  </div>
               )}
               {prevNumRows > 0 && (
                  <div style={{ position: 'relative' }}>
                     {loading && (
                        <div style={{
                           position: 'absolute',
                           top: 0,
                           left: 0,
                           right: 0,
                           bottom: 0,
                           display: 'flex',
                           flexDirection: 'column',
                           alignItems: 'center',
                           justifyContent: 'center',
                           backgroundColor: 'rgba(255, 255, 255, 0.8)',
                           zIndex: 1000
                        }}>
                           <ClipLoader color="#0173d4" loading={loading} size={50} />
                           <p style={{ marginTop: '10px', color: '#0173d4', fontWeight: 'bold' }}>Downloading.......</p>
                        </div>
                     )}
                     <table className="tableBorder">
                        <thead
                           style={{
                              visibility:
                                 props.isHeader !== "false" ? "visible" : "collapse",
                           }}
                        >
                           <tr style={{backgroundColor:"#eee"}}>{getHeader(previousData[0])}</tr>
                        </thead>
                        <tbody>{getRowsData(previousData)}</tbody>
                     </table>
                  </div>
               )}
            </div>
         </div>
      </div>
   )
}
export default GenDocsFilesDownload